import React from 'react';


const Logo = ({ src, alt, onClick }) => (
    <img src={src} className="nare-logo" alt={alt} onClick={() => onClick()} />
)

export default Logo